var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 57 57",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.91699 28.1633C2.91699 14.3101 14.1472 3.07996 28.0003 3.07996C41.8535 3.07996 53.0837 14.3101 53.0837 28.1633C53.0837 42.0164 41.8535 53.2466 28.0003 53.2466C14.1472 53.2466 2.91699 42.0164 2.91699 28.1633ZM28.0003 6.57996C16.0802 6.57996 6.41699 16.2431 6.41699 28.1633C6.41699 40.0834 16.0802 49.7466 28.0003 49.7466C39.9205 49.7466 49.5837 40.0834 49.5837 28.1633C49.5837 16.2431 39.9205 6.57996 28.0003 6.57996Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.417 21.1633C20.417 16.9752 23.8122 13.58 28.0003 13.58C32.1885 13.58 35.5837 16.9752 35.5837 21.1633C35.5837 25.3514 32.1885 28.7466 28.0003 28.7466C23.8122 28.7466 20.417 25.3514 20.417 21.1633ZM28.0003 17.08C25.7452 17.08 23.917 18.9082 23.917 21.1633C23.917 23.4184 25.7452 25.2466 28.0003 25.2466C30.2555 25.2466 32.0837 23.4184 32.0837 21.1633C32.0837 18.9082 30.2555 17.08 28.0003 17.08Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3331 35.7466C18.0796 35.7466 13.7791 39.8328 13.4383 44.9991C13.3747 45.9635 12.5414 46.6938 11.577 46.6302C10.6126 46.5666 9.88231 45.7332 9.94592 44.7688C10.4072 37.7752 16.2237 32.2466 23.3331 32.2466H32.6665C39.7665 32.2466 45.5771 37.7605 46.0519 44.7411C46.1175 45.7053 45.389 46.5402 44.4247 46.6058C43.4604 46.6714 42.6256 45.9428 42.56 44.9786C42.2092 39.822 37.9131 35.7466 32.6665 35.7466H23.3331Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMe);
export default __webpack_public_path__ + "static/media/me.1f1b5933.svg";
export { ForwardRef as ReactComponent };